import { useEffect, useRef } from 'react';

import { ILottie } from '@lottielab/lottie-player/react';

import DownloadAnimation from '@/assets/animations/Download.json';
import LottieAnimation from '@/components/atoms/Lottie';
import { Button } from '@/new/components/shadcn/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/new/components/shadcn/tooltip';

interface DownloadProps {
  downloadStart: boolean;
  downloadComplete: boolean;
  handleDownload: () => void;
  tooltipText: string;
  disabled?: boolean;
}

export function DownloadButton({
  downloadStart,
  downloadComplete,
  handleDownload,
  tooltipText,
  disabled,
}: DownloadProps) {
  const lottieRef = useRef<ILottie | null>(null);

  const switchState = (stateName: string) => {
    lottieRef.current?.interactivity?.trigger(stateName);
  };

  useEffect(() => {
    if (downloadComplete) {
      switchState('complete');
      return;
    }
    if (downloadStart) {
      switchState('start');
    }
  }, [downloadStart, downloadComplete]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="outline" size="sm" onClick={handleDownload} disabled={disabled}>
          <LottieAnimation lottieRef={lottieRef} animationData={DownloadAnimation} className="h-4 w-4" />
          Download
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{tooltipText}</p>
      </TooltipContent>
    </Tooltip>
  );
}
